
import AutoPartsVehicleLookupBase from 'JS/automotive/auto-parts/components/AutoPartsVehicleLookupBase';
import BForm from 'JS/components/blain-form/BForm.vue';
import BSelect from 'JS/components/blain-form/BSelect.vue';
import bugsnagClient from 'JS/global/bugsnag';
import FieldNote from 'JS/components/FieldNote.vue';
import Icon from 'JS/components/Icon.vue';
import Spinner from 'JS/components/Spinner.vue';
import TransitionExpand from 'JS/components/transitions/TransitionExpand.vue';
import UiButton from 'JS/components/UiButton.vue';
import { Component, Inject, Mixins, Watch } from 'vue-property-decorator';
import { ICustomerVehicleService } from 'JS/services/automotive/CustomerVehicleService';

@Component({
	name: 'VehicleLookupForm',
	components: {
		BForm,
		BSelect,
		UiButton,
		FieldNote,
		Icon,
		Spinner,
		TransitionExpand,
	}
})
export default class VehicleLookupForm extends Mixins(AutoPartsVehicleLookupBase) {

	$refs!: {
		form: BForm;
	}

	@Inject('CustomerVehicleService')
	_vehicleService: ICustomerVehicleService;

	error: string | null = null;
	saving: boolean = false;
	noResults: boolean = false;

	async saveVehicle() {
		if (!this.vehicle) {
			return;
		}

		this.noResults = false;
		this.error = null;

		try {
			this.saving = true;
			await this._vehicleService.saveAutoPartsVehicle(this.vehicle);
			this.saving = false;
			window.location.href = '/batteries/list/';
		} catch (e) {
			bugsnagClient.notify(e);
			this.saving = false;
			this.error = "Unable to save vehicle. Please try again.";
		}
	}

	setModel(value: string) {
		const [makeID, modelID] = value.split('_').map(s => parseInt(s));
		if (
			typeof makeID === 'number'
			&& !isNaN(makeID)
			&& typeof modelID === 'number'
			&& !isNaN(modelID)
		) {
			this.modelData = {
				makeID,
				modelID
			};
		} else {
			this.modelData = null;
		};
	}

	created() {
		// If there are no batteries found which match the vehicle, show the no results message.
		const params = new URLSearchParams(window.location.search);

		if (params.has('noresults')) {
			const noresults = params.get('noresults');
			this.noResults = noresults === 'true' ? true : false;
		}
	}

	@Watch('loadingData')
	onLoadingDataChange(loading: boolean) {
		if (loading) {
			this.$refs.form.resetValidation();
		}
	}
}
